import { ReactComponent } from "./arrow-right-fill.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const ArrowRightFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ArrowRightFillIcon;
